var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"vue-simple-context-menu",staticStyle:{"background":"white"},attrs:{"id":_vm.elementId}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }